import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Header from "./components/header";
import Footer from "./components/footer";
import Dosha from "./pages/Dosha";
// import Coming from "./components/coming";
import Stories from "./pages/Stories";
import Book from "./pages/Book";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Home from "./pages/Home";
import AppScripts from "./components/AppScripts";
import ScrollToTop from "./components/ScrollToTop";
import TermsCondition from "./pages/TermsCondition";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {

  return (
    <Router>
      <ScrollToTop />
      <AppScripts />
      <Header />
      {/* <main className="main"> */}
      <Routes>
        {/* <Route path="/Dohsatherapypractice" element={<Dosha />} /> */}
        <Route path="/Dohsatherapypractice" element={<Dosha />} />
        <Route path="/about" element={<About />} />
        <Route path="/book" element={<Book />} />
        <Route path="/stories" element={<Stories />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/terms-and-condition" element={<TermsCondition />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/home" element={<Home />} />
        <Route path="*" element={<Navigate to="/home" replace />} />
      </Routes>
      {/* </main> */}
      <Footer />
    </Router>
  );
}

export default App;